<template>
  <v-content style="height: 100vh">
    <v-img
      src="https://i.pinimg.com/originals/96/59/f6/9659f611daffb8c55b640b0f40336e61.png"
      style="
        background-size:contain;
        position: absolute;
        height: 100vh;
        width: 100vw;
        /*filter: blur(10px) contrast(120%);*/
      "
    >
    </v-img>
    <v-container class="fill-height mb-2" fluid>
      <v-row align="center" justify="center">
        <v-col cols="11" sm="8" md="4" lg="3">
          <v-card class="elevation-12" style="padding-bottom: 15px !important">
            <v-toolbar color="primary" dark flat>
              <v-toolbar-title>Rust Casual: End Game Tools</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-form>
                <v-text-field
                  label="Username"
                  name="login"
                  prepend-icon="mdi-account"
                  type="text"
                  v-model="username"
                  required
                ></v-text-field>
                <v-text-field
                  id="password"
                  :rules="[(v) => !!v || 'Password is required']"
                  label="Password"
                  name="password"
                  prepend-icon="mdi-lock"
                  type="password"
                  v-model="password"
                  @keyup.enter="login"
                  required
                  :append-icon="hidePassword ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="() => (hidePassword = !hidePassword)"
                  :type="hidePassword ? 'password' : 'text'"
                ></v-text-field>
              </v-form>
              <p style="cursor: pointer" @click="forgotPasswordDialog = true">
                Forgot Password
              </p>
              <v-row class="pa-0">
                <v-col cols="12" class="pa-0">
                  <v-btn
                    block
                    color="green"
                    dark
                    :loading="loginLoading"
                    @click="login()"
                    >Login</v-btn
                  >
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-dialog v-model="forgotPasswordDialog" max-width="600px">
      <v-card>
        <v-card-text>
          <h2 class="py-2">Password reset</h2>
          <v-text-field
            label="Username"
            name="login"
            prepend-icon="mdi-account"
            type="text"
            v-model="username"
            required
          ></v-text-field>
          <v-card-actions>
            <v-btn color="grey" dark @click="forgotPasswordDialog = false"
              >cancel</v-btn
            >
            <v-spacer></v-spacer>
            <v-btn color="primary" dark @click="forgotPassword()"
              >Reset Password</v-btn
            >
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="resetPasswordDialog" max-width="600px" persistent>
      <v-card>
        <v-card-text>
          <h2 class="py-2">Enter validation code below</h2>
          <v-form ref="resetPasswordForm">
            <v-text-field
              label="Code"
              name="login"
              :rules="[(v) => !!v || 'The Verification Code is required']"
              prepend-icon="mdi-code"
              type="text"
              v-model="resetCode"
              required
            ></v-text-field>
            <v-text-field
              id="password"
              :rules="[(v) => !!v || 'Password is required']"
              label="New Password"
              name="password"
              prepend-icon="mdi-lock"
              type="password"
              v-model="password"
              @keyup.enter="login"
              required
              :append-icon="hidePassword ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="() => (hidePassword = !hidePassword)"
              :type="hidePassword ? 'password' : 'text'"
            ></v-text-field>
          </v-form>

          <v-card-actions>
            <v-btn color="grey" dark @click="resetPasswordDialog = false"
              >cancel</v-btn
            >
            <v-spacer></v-spacer>
            <v-btn color="primary" dark @click="tryResetCode()">Submit</v-btn>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog persistent v-model="newPasswordDialog" max-width="600px">
      <v-card>
        <v-card-text>
          <h2 class="py-2">New Password</h2>
          <p>
            Because this account was made by an Admin, your tempory password
            needs to be reset. To reset please type your Desired Password below
            and click confirm.
          </p>
          <v-text-field
            id="password"
            :rules="[(v) => !!v || 'Password is required']"
            label="Password"
            name="password"
            prepend-icon="mdi-lock"
            type="password"
            v-model="newPassword"
            @keyup.enter="changeMandatoryPassword"
            required
            :append-icon="hidePassword ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="() => (hidePassword = !hidePassword)"
            :type="hidePassword ? 'password' : 'text'"
          ></v-text-field>
          <v-card-actions>
            <v-btn
              :loading="changeTempPasswordLoading"
              color="primary"
              dark
              @click="changeMandatoryPassword()"
              >Confirm</v-btn
            >
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-content>
</template>

<script>
  import { mapGetters } from "vuex";
  import { auth } from "@/firebase.js";

  export default {
    computed: {
      ...mapGetters(["siteData", "currentUser", "currentUserData"]),
    },
    data: () => ({
      newPasswordDialog: false,
      newPassword: "",
      changeTempPasswordLoading: false,
      hidePassword: true,
      email: "",
      password: "",
      loginLoading: false,
      loginGoogleLoading: false,
      username: "",
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+/.test(v) || "E-mail must be valid",
      ],

      // Reset Passowrd
      resetCode: "",
      resetPasswordDialog: false,
      forgotPasswordDialog: false,
    }),
    watch: {},
    mounted() {},
    methods: {
      login() {
        this.loginLoading = true;
        let _this = this;
        this.$cognitoAuth.authenticate(
          this.username,
          this.password,
          (err, result) => {
            if (err != null) {
              if (err.code == "NewPasswordRequired") {
                this.newMandatoryPassword();
              } else {
                this.$swal({
                  title: "Error",
                  text: err.message,
                  type: "error",
                  confirmButtonText: "Ok",
                });
              }
            } else {
              this.$store.dispatch("login", result);
            }
            this.loginLoading = false;
          }
        );
      },

      // Forgot Password Section
      forgotPassword() {
        this.$store.dispatch("requestPasswordResetCode", {
          username: this.username,
        });
        this.$swal({
          title: "Check your inbox",
          text:
            "If we find an account with your username you will receive a password reset code.",
          type: "success",
          confirmButtonText: "Ok",
        });
        this.forgotPasswordDialog = false;
        this.resetPasswordDialog = true;
      },
      tryResetCode() {
        this.$store
          .dispatch("resetPasswordWithCode", {
            code: this.resetCode,
            username: this.username,
            password: this.password,
          })
          .then((res) => {
            if (res.Result == "Success") {
              this.$swal({
                title: "Success",
                text: "Your password has been Reset",
                type: "success",
                confirmButtonText: "Ok",
              });
              this.resetPasswordDialog = false;
            } else {
              this.$swal({
                title: "Whoops",
                text: "The code that was entered was Invalid",
                type: "warning",
                confirmButtonText: "Ok",
              });
            }
          });
      },
      // End Forgot Password Section

      newMandatoryPassword() {
        this.newPasswordDialog = true;
      },
      changeMandatoryPassword() {
        this.changeTempPasswordLoading = true;
        this.$cognitoAuth.handleNewPassword(
          this.username,
          this.newPassword,
          (err, result) => {
            if (err != null) {
              this.$swal({
                title: "Error",
                text: err.message,
                type: "error",
                confirmButtonText: "Ok",
              });
            } else {
              this.$store.dispatch("initAuth");
            }
            this.changeTempPasswordLoading = false;
          }
        );
      },
    },
  };
</script>
